import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - BOM Predictive image
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxBomPredictiveReducer(state = initialState.crashboxxBomPredictiveSearch, action){

    switch(action.type)
    {
        case types.GET_PREDICTIVEIMAGE_REQUEST:
            return {...state, binaries: null, error: null, isSearching: true};
        case types.GET_PREDICTIVEIMAGE_SUCCESS:
            return {...state, binaries: action.data.binaries, error: null, isSearching: false};
        case types.GET_PREDICTIVEIMAGE_ERROR:
            return {...state, binaries: null, error: action.error, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxBomPredictiveReducer.js